import PropTypes from "prop-types"
import styled from "styled-components"
import {
  color,
  compose,
  layout,
  system,
  typography,
  space,
} from "styled-system"

import iconPaths, { iconStrokeWidths } from "./data"

const Svg = styled.svg`
  ${compose(color, layout, typography, space)}
`
const Path = styled.path`
  ${system({
    fill: {
      property: "fill",
      scale: "colors",
    },
    stroke: {
      property: "stroke",
      scale: "colors",
    },
  })}
`

const Icon = ({ color, height, icon, size, stroke, width, ...props }) => {
  const iconPath = iconPaths[icon]
  const strokeWidth = iconStrokeWidths[icon]

  if (iconPath) {
    return (
      <Svg
        fill="none"
        height={height || size}
        viewBox={`0 0 ${size} ${size}`}
        width={width || size}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <Path
          d={iconPath()}
          fill={icon.includes("solid") ? color : "none"}
          stroke={stroke || color}
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={strokeWidth || 2}
        />
      </Svg>
    )
  } else {
    return ""
  }
}

Icon.propTypes = {
  color: PropTypes.string,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  icon: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  stroke: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
}

Icon.defaultProps = {
  color: "black",
  size: 24,
}

export default Icon
